document.addEventListener('DOMContentLoaded', function () {
  /*
   * Blob cursor
   */
  var cursor = document.querySelector('.blob');

  if (cursor) {
    document.addEventListener('mousemove', function (e) {
      cursor.style.transform =
        'translate3d(calc(' + e.clientX + 'px - 50%), calc(' + e.clientY + 'px - 50%), 0)';
    });
  }

  /*
   * Shopify Forms styling
   */
  var FORM_SELECTOR = '[data-forms-id="forms-root-1030976"]';

  var DARK = '#06060c';
  var PURPLE = '#3e048e';
  var WHITE = '#ffffff';
  var WHITE_SOFT = 'rgba(255, 255, 255, 0.65)';
  var BORDER = 'rgba(255, 255, 255, 0.35)';

  var observerStarted = false;
  var stylingQueued = false;
  var replacementSuccessPushed = false;

  function setImportant(element, property, value) {
    if (!element) return;
    element.style.setProperty(property, value, 'important');
  }

  function setNormal(element, property, value) {
    if (!element) return;
    element.style.setProperty(property, value);
  }

  function applyShopifyFormStyles() {
    try {
      var formRoot = document.querySelector(FORM_SELECTOR);

      if (!formRoot) return false;

      var embed = formRoot.querySelector('shopify-forms-embed');

      if (!embed || !embed.shadowRoot) return false;

      var root = embed.shadowRoot;

      /*
       * Host-level variables
       */
      setNormal(embed, '--inline-container-max-width', '100%');
      setNormal(embed, '--container-max-w', '100%');
      setNormal(embed, '--app-embed-width', '100%');

      setNormal(embed, '--container-background-color', DARK);
      setNormal(embed, '--form-background-color', DARK);
      setNormal(embed, '--form-text-color', WHITE);
      setNormal(embed, '--form-placeholder-color', WHITE_SOFT);
      setNormal(embed, '--body-text-color', WHITE);
      setNormal(embed, '--heading-text-color', WHITE);
      setNormal(embed, '--link-text-color', WHITE);

      setNormal(embed, '--form-field-border', '0 0 0 1px ' + BORDER);
      setNormal(embed, '--form-field-border-focused', '0 0 0 2px ' + WHITE);

      setNormal(embed, 'width', '100%');
      setNormal(embed, 'max-width', '100%');
      setNormal(embed, 'display', 'block');

      /*
       * Width/background containers
       */
      var inlineSection = root.querySelector('section[class*="_inline_"]');
      var formWrapper = root.querySelector('[data-sizing="form-wrapper"]');
      var formContainer = root.querySelector('section[class*="_formContainer_"]');
      var grid = root.querySelector('[class*="_grid_"]');

      [inlineSection, formWrapper, formContainer].forEach(function (element) {
        if (!element) return;

        setImportant(element, 'width', '100%');
        setImportant(element, 'max-width', '100%');
        setImportant(element, 'background', DARK);
      });

      setImportant(inlineSection, 'margin-inline', 'auto');
      setImportant(grid, 'background', DARK);

      /*
       * Inputs - avoid checkboxes, hidden inputs, files, submit buttons.
       */
      var inputs = root.querySelectorAll(
        'input:not([type="checkbox"]):not([type="hidden"]):not([type="file"]):not([type="submit"]), textarea'
      );

      inputs.forEach(function (input) {
        setImportant(input, 'background-color', DARK);
        setImportant(input, 'color', WHITE);
        setImportant(input, 'box-shadow', '0 0 0 1px ' + BORDER);
        setImportant(input, 'border-color', BORDER);
      });

      /*
       * Text
       */
      root.querySelectorAll(
        'label, legend, p, span, h1, h2, h3, div[class*="_birthdayText_"]'
      ).forEach(function (element) {
        setImportant(element, 'color', WHITE);
      });

      /*
       * File upload "Add file" p
       */
      var fileUploadText = root.querySelector(
        '[class*="_formFileInput_"] p[class*="_formFileInputButton_"]'
      );

      if (fileUploadText) {
        setImportant(fileUploadText, 'background-color', PURPLE);
        setImportant(fileUploadText, 'color', WHITE);
      }

      /*
       * Checkboxes
       */
      root.querySelectorAll('input[type="checkbox"]').forEach(function (checkbox) {
        setImportant(checkbox, 'accent-color', PURPLE);
        setImportant(checkbox, 'box-shadow', 'none');
        setImportant(checkbox, 'border', '1px solid ' + PURPLE);
        setImportant(checkbox, 'outline', 'none');
      });

      /*
       * Disclaimer
       */
      root.querySelectorAll(
        '[class*="_formDisclaimer_"], [class*="_formDisclaimer_"] p'
      ).forEach(function (element) {
        setImportant(element, 'font-size', '1em');
        setImportant(element, 'line-height', 'normal');
      });

      /*
       * Success state
       */
var successSection = root.querySelector('section[aria-label="Success"]');

if (successSection) {
  setImportant(successSection, 'background-color', PURPLE);
  setImportant(successSection, 'color', WHITE);
  setImportant(successSection, 'display', 'flex');
  setImportant(successSection, 'align-items', 'center');
  setImportant(successSection, 'justify-content', 'center');
  setImportant(successSection, 'border-radius', '1em');

  successSection.querySelectorAll('h1, h2, h3, p, span, div, button').forEach(function (element) {
    setImportant(element, 'color', WHITE);
  });

  if (!replacementSuccessPushed) {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: 'replacement_form_success',
      form_id: '1030976',
      form_name: 'Replacement Form'
    });

    replacementSuccessPushed = true;

    console.log('[Shopify Forms] dataLayer event pushed: replacement_form_success');
  }
}

      formRoot.classList.add('shopify-form-ready');

      return true;
    } catch (error) {
      console.error('[Shopify Forms] Error applying styles:', error);
      return false;
    }
  }

  function queueStyleUpdate() {
    if (stylingQueued) return;

    stylingQueued = true;

    requestAnimationFrame(function () {
      stylingQueued = false;
      applyShopifyFormStyles();
    });
  }

  function startObserver() {
    if (observerStarted) return;

    var formRoot = document.querySelector(FORM_SELECTOR);
    var embed = formRoot ? formRoot.querySelector('shopify-forms-embed') : null;

    if (!embed || !embed.shadowRoot) return;

    observerStarted = true;

    var observer = new MutationObserver(function () {
      queueStyleUpdate();
    });

    /*
     * Important:
     * Watch DOM swaps only.
     * Do NOT watch attributes, otherwise our own style changes can loop.
     */
    observer.observe(embed.shadowRoot, {
      childList: true,
      subtree: true
    });
  }

  var attempts = 0;
  var maxAttempts = 40;

  var interval = setInterval(function () {
    attempts++;

    var success = applyShopifyFormStyles();

    if (success) {
      startObserver();
      clearInterval(interval);
      return;
    }

    if (attempts >= maxAttempts) {
      clearInterval(interval);

      var formRoot = document.querySelector(FORM_SELECTOR);

      if (formRoot) {
        formRoot.classList.add('shopify-form-ready');
      }

      console.warn('[Shopify Forms] Stopped after max attempts');
    }
  }, 250);
});